import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { setAuthToken, setRefreshToken } from '../utils/auth';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000;
        if (!decoded || decoded.exp < now) {
          navigate('/login', { replace: true });
          return;
        }
        setAuthToken(token);
        navigate('/tareas', { replace: true });
      } catch {
        navigate('/login', { replace: true });
      }
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate, searchParams]);

  return null;
};

export default AuthCallback;
